import React from "react"
import { Link } from "gatsby"
import { css } from "styled-components"
import { styled } from 'themes'

export const Section = styled.section`
  height: 522px;
  width: 100%;
`

export const Container = styled.div``

export const Content = styled.div`
  max-width: 1366px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding-left: 124px;
  padding-right: 168px;
  position: relative;
  display: flex;
  align-items: center;
`

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`

export const ActionContent = styled.div`
  flex: 1;
  margin-right: 12px;
`

export const Logo = styled.div`
  flex-basis: 90px;
  padding-right: 16px;
  > img {
    width: 90px;
  }
`

export const Headline = styled.h3`
  color: ${({ theme }) => theme.color.white};
  font-weight: bold;
  font-size: 38px;
  line-height: 38px;
  width: 100%;
`

export const Action = styled.div`
  display: flex;
`

export const ActionButton = styled((props: any) => <Link {...props} />)`
  background: ${({ theme }) => theme.color.primary};
  color: ${({ theme }) => theme.color.white};
  border-radius: 4px;
  outline: none;
  border: none;
  padding: 12px 70px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  cursor: pointer;
  margin-right: 16px;
  &:last-child {
    margin-right: 0;
  }
  &:hover {
    color: ${({ theme }) => theme.color.white};
  }
`

export const TestimonialBox = styled.div`
  flex-basis: 443px;
  background: ${({ theme }) => theme.color.white};
  padding: 34px 60px 34px 40px;
  border-radius: 8px;
  box-shadow: 0px 1px 73px #1a282828;
`

export const Avatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
  margin-bottom: 14px;
`

export const Description = styled.p`
  color: ${({ theme }) => theme.color.softBlack};
  font-size: 18px;
  position: relative;
  padding-bottom: 20px;
  &::after {
    content: "";
    width: 27px;
    height: 2px;
    background: ${({ theme }) => theme.color.primary};
    position: absolute;
    bottom: 0;
    left: 0;
  }
`

export const Name = styled.div`
  font-size: 18px;
  color: ${({ theme }) => theme.color.primary};
  font-weight: bold;
`

export const MutedText = styled.div`
  color: #9b9b9b;
  font-size: 12px;
`

export const Navigation = styled.div`
  position: absolute;
  right: 168px;
  bottom: 20px;
  z-index: 1;
  display: flex;
`

const NavigationBtn = styled((props: any) => <div {...props} />)`
  color: #1b1a1a;
  font-size: 14px;
  font-weight: bold;
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  position: relative;
  padding-bottom: 4px;
  user-select: none;
  transition: all 0.2s;
  &::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    background: #1b1a1a;
    bottom: 0;
  }
  ${props =>
    props.active &&
    css`
      color: ${({ theme }) => theme.color.primary};
      &::before {
        content: "";
        border: solid ${({ theme }) => theme.color.primary};
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 3px;
        position: absolute;
        bottom: -3px;
      }
      &::after {
        background: ${({ theme }) => theme.color.primary};
      }
    `}
`

export const Previous = styled(NavigationBtn)`
  text-align: right;
  padding-left: 20px;
  &::after {
    right: 0;
  }
  ${props =>
    props.active &&
    css`
      &::before {
        transform: rotate(135deg);
        left: 0;
      }
    `}
`

export const Next = styled(NavigationBtn)`
  margin-left: 18px;
  padding-right: 20px;
  text-align: left;
  &::after {
    left: 0;
  }
  ${props =>
    props.active &&
    css`
      &::before {
        transform: rotate(-45deg);
        right: 0;
      }
    `}
`
